
import { defineComponent, ref } from 'vue'
import { useRouter, RouteLocationNormalized } from 'vue-router'
import { useStore } from 'vuex'
import { FormDataStructure } from '@/contracts/forms/FieldContracts'
import { getStage2FormDataStructure } from '@/composables/formdata'
import Form from '@/components/Form.vue'

export default defineComponent(
{
    name: 'Search',
    components:
    {
        Form
    },
    setup()
    {
        // Load router:
        const router = useRouter()
        // Use vuex:
        const store = useStore()
        // Get form data:
        const stage1Data = store.getters['formData/stage1Data']
        const stage2Data = store.getters['formData/stage2Data']
        // Determine search type:
        const grantType = ref(1)
        if(stage1Data.wasasoldier)
        {
            grantType.value = 3
        }

        // Set fieldsets:
        const fieldsets =
        [
            {
                name: 'keywords',
                text: 'Do you have any keywords to search by?'
            },
            {
                name: 'monthofdeath',
                text: 'What was their month of death?'
            },
            {
                name: 'dayofdeath',
                text: 'What was their day of death?'
            },
            {
                name: 'yearofprobate',
                text: 'What was their year of probate?'
            },
            {
                name: 'monthofprobate',
                text: 'What was their month of probate?'
            },
            {
                name: 'dayofprobate',
                text: 'What was their day of probate?'
            },
            {
                name: 'regimentalnumber',
                text: 'What was their regimental number?'
            }
        ]
        // Set fields:
        const fields = getStage2FormDataStructure(grantType.value, stage2Data)
        // Set buttons:
        const buttons =
        {
            submit:
            {
                name: 'submit',
                type: 'Submit',
                text: 'Save and continue'
            }
        }
        // Handle submission:
        const saveFormData = (formData: FormDataStructure, backButtonRoute?: string) =>
        {
            // Store form data with grant type:
            store.commit('formData/setStage2Data', Object.assign(formData, { grantType: grantType }))
            // Set router config:
            const routerConfig =
            {
                name: 'Results'
            } as RouteLocationNormalized
            // If back button has been set, push to config:
            if(backButtonRoute !== undefined)
            {
                routerConfig.params = { back: backButtonRoute }
            }
            // Push to router:
            router.push(routerConfig)
        }
        // If there's no fields, move to results:
        if(Object.keys(fields).length === 0)
        {
            saveFormData({} as FormDataStructure, 'Home')
        }

        // Return data:
        return {
            fieldsets,
            fields,
            buttons,
            saveFormData
        }
    }
})
